<template>
    <div class="fae-charts-trend">
        <div class="charts" v-if="hasNumber">
            <dv-charts :option="trendOption"/>
        </div>
        <noData v-else :mes="'暂无数据'"></noData>
    </div>
</template>

<script>
    import noData from "@/view/schedule/components/noData";
    import common from '@/api/common';
    import Common from "../../../../public/js/common";

    export default {
        name: "trendChart",
        props: {
            cdata: Array,
            department: String,  // 部门ID
            ctype: Number  // 0 本年 1 本月 2 本周
        },
        components: {noData},
        data() {
            return {
                hasNumber: true, // 是否有数据
                trendOption: {},
            }
        },

        watch: {
            'cdata': function () {
                if (this.cdata.length > 0) {
                    this.formatData()
                    // this.hasNumber = this.hasOrNot()
                }
            }
        },

        mounted() {
            // this.formatData()
        },
        methods: {
            // 根据当前日期显示对应的数据
            calcYear() {
                let montdata = [
                    '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'
                ];
                let currnetDay = new Date().getMonth() + 1;
                let temdata = [];
                montdata.map((item, index) => {
                    if (index < currnetDay) {
                        temdata.push(item)
                    }
                })
                return temdata
            },
            calcMonth() {
                let currnetDay = new Date().getDate();
                let montdata = [];
                if (currnetDay > 15) {
                    montdata = [
                        '1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
                        '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
                        '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'
                    ];
                } else {
                    montdata = [
                        '1日', '2日', '3日', '4日', '5日', '6日', '7日', '8日', '9日', '10日',
                        '11日', '12日', '13日', '14日', '15日', '16日', '17日', '18日', '19日', '20日',
                        '21日', '22日', '23日', '24日', '25日', '26日', '27日', '28日', '29日', '30日', '31日'
                    ];

                }
                // let currnetDay = 31;
                let temdata = [];
                montdata.map((item, index) => {
                    if (index < currnetDay) {
                        temdata.push(item)
                    }
                })
                return temdata
            },
            calcWeeks() {
                let currentWeek = this.Common.formatYearWeek(new Date())
                let montdata = [
                    `${currentWeek - 6}周`,
                    `${currentWeek - 5}周`,
                    `${currentWeek - 4}周`,
                    `${currentWeek - 3}周`,
                    `${currentWeek - 2}周`,
                    `上周`,
                ];
                return montdata
            },
            calcWeeksValue() {
                let cdata = this.$props.cdata[0];
                let temarr = [];
                let mdata = ['WEEK6', 'WEEK5', 'WEEK4', 'WEEK3', 'WEEK2', 'WEEK1'];
                for (var i = 0; i < mdata.length; i++) {
                    mdata[i] = mdata[i].toUpperCase();
                }
                for (let i = 0; i <= mdata.length; i++) {
                    // console.log(mdata[i])
                    for (let j in cdata) {
                        if (mdata[i] == j) {
                            temarr.push(parseInt(cdata[j]))
                        }
                    }
                }
                return temarr
            },

            calcWeek() {
                let montdata = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
                let temdata = [];
                montdata.map((item, index) => {
                  if(item>0){
                    temdata.push(item)
                  }
                })
                return montdata
            },
            calcWeekValue() {
                let cdata = this.$props.cdata[0];
                let temarr = [];

                let mdata = ['MON', 'TUES', 'WED', 'THUR', 'FRI', 'SAT', 'SUN'];
                for (var i = 0; i < mdata.length; i++) {
                    mdata[i] = mdata[i].toUpperCase();
                }
                for (let i = 0; i <= mdata.length; i++) {
                    for (let j in cdata) {
                        if (mdata[i] == j) {
                            temarr.push(parseInt(cdata[j]))
                        }
                    }
                }
                return temarr
            },

            // 显示当前数组的值
            calcYearValue() {
                let cdata = this.$props.cdata[0];
                let temarr = [];
                let mdata = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                for (var i = 0; i < mdata.length; i++) {
                    mdata[i] = mdata[i].toUpperCase();
                }
                for (let i = 0; i <= mdata.length; i++) {
                    // console.log(mdata[i])
                    for (let j in cdata) {
                        if (mdata[i] == j) {
                            temarr.push(cdata[j])
                        }
                    }
                }

                let currnetDay = new Date().getMonth() + 1;
                let temdata = [];
                temarr.map((item, index) => {
                    if (index < currnetDay) {
                        temdata.push(item)
                    }
                })
                // console.log(temdata)
                return temdata
            },
            calcMonthValue() {
                let cdata = this.$props.cdata[0];
                let temarr = [];

                let mdata = ['DAY1', 'DAY2', 'DAY3', 'DAY4', 'DAY5', 'DAY6', 'DAY7', 'DAY8', 'DAY9', 'DAY10',
                    'DAY11', 'DAY12', 'DAY13', 'DAY14', 'DAY15', 'DAY16', 'DAY17', 'DAY18', 'DAY19', 'DAY20',
                    'DAY21', 'DAY22', 'DAY23', 'DAY24', 'DAY25', 'DAY26', 'DAY27', 'DAY28', 'DAY29', 'DAY30', 'DAY31'];
                for (let i = 0; i <= mdata.length; i++) {
                    // console.log(mdata[i])
                    for (let j in cdata) {
                        if (mdata[i] == j) {
                            temarr.push(parseInt(cdata[j]))
                        }
                    }
                }
                // console.log(temarr)

                let currnetDay = new Date().getDate();
                // let currnetDay = 31;
                let temdata = [];
                temarr.map((item, index) => {
                    if (index < currnetDay) {
                        temdata.push(item)
                    }
                })
                // console.log(temdata)
                return temdata
            },


            formatData() {
                let xdata = [], ydata = [];
                // ctype 0本年 1本月 2前六周 3本周  4上周
                if (this.ctype == 0) {
                    xdata = this.calcYear();
                    ydata = this.calcYearValue();
                } else if (this.ctype == 1) {
                    xdata = this.calcMonth();
                    ydata = this.calcMonthValue();
                } else if (this.ctype == 2) {
                    xdata = this.calcWeeks();
                    ydata = this.calcWeeksValue();
                }else if (this.ctype == 3) {
                    xdata = this.calcWeek();
                    ydata = this.calcWeekValue();
                }else if (this.ctype == 4) {
                    xdata = this.calcWeek();
                    ydata = this.calcWeekValue();
                }

                this.hasNumber = this.hasOrNot(ydata)


                let maxArr = JSON.parse(JSON.stringify(ydata));
                let maxValue = 30;

                if (maxArr.sort(this.Common.sortNum)[0] < 30) {
                    maxValue = 30
                } else {
                    maxValue = maxArr.sort(this.Common.sortNum)[0]
                }

                // console.log(xdata)
                // console.log(this.ctype)
                // console.log("0 本年 1 本月 2 本周")
                // console.log(xdata)
                console.log(ydata)


                let legenddata = [
                    {
                        name: this.department,
                        color: '#00baff'
                    }
                ];
                let seriesdata = [
                    {
                        name: this.department,
                        data: ydata,
                        type: 'bar', // 矩阵图
                        gradient: {
                            color: ['#37a2da', '#67e0e3']
                        },
                        // 显示文字
                        label: {
                            show: true,
                            position: 'top',
                            // offset: [0, 0],
                            style: {
                                fill: '#37a2da'
                            },
                            formatter: function (params) {
                                if (params.value > 0) {
                                    return params.value;
                                } else {
                                    return ''
                                }
                            }
                        }
                    },
                ];
                this.trendOption = {
                    legend: {
                        data: legenddata,
                        textStyle: {
                            // fill: '#fff'
                        }
                    },
                    xAxis: {
                        // boundaryGap: false,
                        data: xdata,
                        axisLine: {
                            style: {
                                stroke: '#999'
                            }
                        },
                        axisLabel: {
                            style: {
                                fill: '#999'
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    yAxis: {
                        data: 'value',
                        splitLine: {
                            show: true,
                            style: {
                                stroke: '#eee'
                            }
                        },
                        axisLine: {
                            style: {
                                stroke: '#999'
                            }
                        },
                        axisLabel: {
                            style: {
                                fill: '#999'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        min: 0,
                        max: maxValue
                    },
                    series: seriesdata
                }
            },

            // 判断是否有数据
            hasOrNot(arr) {
                let temarr = Object.values(arr).sort().reverse();
                // console.log(temarr)
                if (temarr[0] > 0) {
                    return true
                } else {
                    return false
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .charts {
        width: 100%;
        height: 300px;

        .dv-charts-container {
            position: relative;
            top: -40px
        }
    }
</style>